import React, { useState } from 'react';
import moment from 'moment';
import { timeAgo } from '../utils/utils';
import { Check, CheckCircle, Link, MessageCircleCode, Send, Trash2, XCircle } from 'lucide-react';
import { useSocket } from '../Context/SocketContext';
import { infoUser } from '../utils/auth';
import { useNavigate } from "react-router-dom";


const TabPaiementItem = ({ s, init, type = "stream", index = 0 }) => {
    const { socket, socketSport, editDB } = useSocket()
    const mapStatus = { "paid": "bcs","wait_info_ok":"bcs3 cb", "cancel": "bcgrey4", "done": "bcbulletw1", "refuse": "bce", "wait_ask": "bcorange", "wait": "bcgrey3" }
    const mapTypePay = {
        streaming: { label: "Streaming", cls: "bce cw" },
        sport: { label: "Sport", cls: "bcs cw" },
        vitrine: { label: "Vitrine", cls: "bcw cb" },
        premium: { label: "Premium", cls: "bcyellow cb" }
    }
    const typeConf = mapTypePay[s.type || "streaming"] || mapTypePay.streaming
    const [openStatus, setOpenStatus] = useState(false)
    const [openValid, setOpenValid] = useState(false)
    const [openAsk, setOpenAsk] = useState(false)
    const [loading, setLoading] = useState(null)
    const [copied, setCopied] = useState(false)
    const navigate = useNavigate();
    const matchSocket = type == "stream" ? socket : socketSport

    const user = infoUser();

    const copyUrl = () => {
        if (!s.url_paiement) return
        navigator.clipboard.writeText(s.url_paiement)
        setCopied(true)
        setTimeout(() => setCopied(false), 1500)
    }

    const validPaiementByEmail = () => {
        if (s.email && user.expecttoken && s.id) {
            setLoading('validEmail')
            matchSocket.emit('empire_valid_paiement_by_email', {
                token: user.expecttoken,
                email: s.email,
                nameAdmin: user.name,
                idAskPaiement: s.id
            }, (e) => {
                setLoading(null)
                init()
                console.log(e);
            })
        }
    }
    const validPaiement = () => {
        if (s.user_id && user.expecttoken && s.id) {
            setLoading('valid')
            matchSocket.emit('empire_valid_paiement', {
                token: user.expecttoken,
                idUser: parseInt(s.user_id),
                nameAdmin: user.name,
                idAskPaiement: s.id
            }, (e) => {
                setLoading(null)
                init()
                console.log(e);
            })
        }
    }
    const delitPaiement = () => {
        if (!user.expecttoken || !s.id) return;
        const confirmDelete = window.confirm(
            "Êtes-vous sûr de vouloir supprimer ce paiement ? Cette action est irréversible."
        );
        if (!confirmDelete) return;
        setLoading('delete')
        matchSocket.emit(
            'empire_delete_ask_paiement',
            {
                token: user.expecttoken,
                idAskPaiement: s.id
            },
            (e) => {
                setLoading(null)
                init();
                console.log(e);
            }
        );
    };
    const changeStatus = (status) => {
        editDB(matchSocket, "askpaiement", { id: s.id }, { status }, false, () => {
            init()
        })
    }
    const changeStatusInfo = (status) => {
        if (s.user_id && user.expecttoken && s.id) {
            matchSocket.emit('empire_change_status_info_payment', {
                token: user.expecttoken,
                id_paiement: s.id,
                status
            }, (e) => {
                setOpenAsk(false)
                init()
                console.log(e);
            })
        }
    }
    const refusePaiement = () => {
        if (s.user_id && user.expecttoken && s.id) {
            matchSocket.emit('empire_refuse_paiement', {
                token: user.expecttoken,
                idUser: parseInt(s.user_id),
                nameAdmin: user.name,
                idAskPaiement: s.id
            }, (e) => {
                init()
                console.log(e);
            })
        }
    }
    return (
        <div className='py1 '>
            <div className='item-line-paiement-tab jcsb'>
                {/** INFO */}
                <div className='df gap1'>
                    <div className='cw fr tab-01-paiement df fdc'>
                        <p>{timeAgo(s.date)}</p>
                        <p className='fs05' style={{ opacity: 0.6 }}>{moment(s.date).format('DD/MM/YYYY HH:mm')}</p>
                        <span className='pay-counter'>#{s.id}</span>
                    </div>
                    <div className='tab-02-paiement df aifs'>
                        {s.status && (
                            <button onClick={() => setOpenStatus(!openStatus)} className={`fl cp ${mapStatus[s.status]} cw`} style={{ fontSize: "0.8em", borderRadius: "5px", padding: "0.3em 0.6em" }}>{s.status}</button>
                        )}
                        {!s.status && (
                            <button onClick={() => setOpenStatus(!openStatus)} className={`fl cp cw`} style={{ fontSize: "0.8em", borderRadius: "5px", padding: "0.3em 0.6em" }}>Aucun</button>
                        )}
                    </div>
                    <div className='tab-03-paiement df fdc fr'>
                        <p className='truncate cw fs1' >{s.email}</p>
                        <div style={{ fontSize: "0.8em" }} className='df gap1 fl cw'>
                            <p>{s.firstname}</p>
                            <p>{s.lastname}</p>
                        </div>
                        {s?.country&&(
                            <p className='cw fi'>{s.country}</p>

                        )}
                    </div>
                    <div className='tab-04-paiement df fdc fr'>
                        <p className='fl cw ' style={{ fontSize: "0.8em" }}>{s.ip_adress}</p>
                        
                    </div>
                    <div className='tab-05-paiement df aic fr gap1'>
                        <p className='bcw cb fr' style={{ borderRadius: "5px", padding: "0.3em 0.5em" }}>{s.price}€</p>
                        <p className={`${typeConf.cls} fr`} style={{ borderRadius: "5px", padding: "0.3em 0.5em" }}>{typeConf.label}</p>
                        {s.method && (
                            <p className='bcs cw fr' style={{ borderRadius: "5px", padding: "0.3em 0.5em" }}>{s.method}</p>
                        )}
                        {(s.date_confirm_paid && s.status == "cancel") && (
                            <span className='df aic gap1 bce cw fr' style={{ fontSize: "0.7em", borderRadius: "5px", padding: "0.2em 0.5em" }}>
                                <XCircle size={12} color='#fff' /> Payé annulé
                            </span>
                        )}
                    </div>
                </div>
                {/** ACTION */}
                <div className='df gap1 pay-actions'>
                    {s.url_paiement && (
                        <button className='pay-act-btn' onClick={copyUrl} title="Copier le lien de paiement">{copied ? <Check size={22} color='#15992f' /> : <Link size={22} color='#fff' />}</button>
                    )}
                    <button className='pay-act-btn' onClick={() => navigate(type === "sport" ? "/message_user_sport" : `/message_user/${s.user_id}`, { state: { search: s.email } })} ><MessageCircleCode size={22} color='#fff' /></button>
                    {s.status === "wait_ask" && (
                        <button className='pay-act-btn' onClick={() => setOpenAsk(!openAsk)} ><Send size={22} color='#ffa500' /></button>
                    )}
                    {s.status !== "wait_ask" && (
                        <button className='pay-act-btn' onClick={() => setOpenValid(!openValid)} ><CheckCircle size={22} color='#15992f' /></button>
                    )}
                    <button className='pay-act-btn' disabled={loading === 'delete'} onClick={() => delitPaiement()} >{loading === 'delete' ? <span className='loader sm'></span> : <Trash2 size={22} color='#f71717' />}</button>
                </div>
            </div>
            {/** STATUS CHNAGE */}
            {openStatus && (
                <div className='paiement-action-panel'>
                    <p className='panel-title cw'>Changer de statut</p>
                    <div className='panel-actions'>
                        <button onClick={() => { changeStatus(null); setOpenStatus(false) }} className={`panel-btn ${!s.status ? "active" : ""}`} >Aucun</button>
                        {Object.keys(mapStatus).map((ms) => (
                            <button onClick={() => { changeStatus(ms); setOpenStatus(false) }} className={`panel-btn ${s.status == ms ? "active" : ""}`} >{ms}</button>
                        ))}
                    </div>
                </div>
            )}
            {openValid && (
                <div className='paiement-action-panel'>
                    <p className='panel-title cw'>Verifier le paiement</p>
                    <div className='panel-actions'>
                        <button onClick={validPaiement} disabled={loading === 'valid'} className='panel-btn valid' >{loading === 'valid' ? <span className='loader sm'></span> : "Valider"}</button>
                        <button onClick={validPaiementByEmail} disabled={loading === 'validEmail'} className='panel-btn valid' >{loading === 'validEmail' ? <span className='loader sm'></span> : "Valider par email"}</button>
                        <button onClick={refusePaiement} className='panel-btn danger'>Refuser</button>
                    </div>
                </div>
            )}
            {openAsk && (
                <div className='paiement-action-panel'>
                    <p className='panel-title cw'>Demande de paiement</p>
                    <div className='panel-actions'>
                        <button onClick={() => changeStatusInfo('wait_info_ok')} className='panel-btn valid'>Envoyer les infos</button>
                        <button onClick={refusePaiement} className='panel-btn danger'>Refuser</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TabPaiementItem;